import React from 'react';
import { Page, Document, Text, StyleSheet, View } from '@react-pdf/renderer';
// import ProposalTitle from './ProposalTitle'
import TopProposal from './TopProposal';
import BillTo from './BillTo';
import Thanks from './Thanks';
import ProposalNo from './ProposalNo';
import ProposalVehicle from './ProposalVehicle';
import ProposalContract from './ProposalContract';
import ProposalItemsTable from './ProposalItemsTable';
import ProposalCondition from './ProposalCondition';
import ProposalSignature from './ProposalSignature';
import Seller from './Seller';
import ProposalFreight from './ProposalFreight';
import ProposalPayment from './ProposalPayment';
import ProposalComercialCondictions from './ProposalComercialCondictions';
import { displayDate } from '@iso/lib/helpers/utility';
import Address from './Address';

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingBottom: 30,
        paddingLeft:30,
        paddingRight:30,
        lineHeight: 1.5,
        flexDirection: 'column',
    }, 
    logo: {
        width: 74,
        height: 66,
        marginLeft: 'auto',
        marginRight: 'auto'
    }
});

const Proposal = ({ invoice }) => {
    // console.log(invoice)
    // console.log(invoice.currentBlocks)
    const currentBlocks = invoice.currentBlocks.map(item => { return item.name });
    const verify = invoice?.condicaoComercial !== '' && ( currentBlocks.indexOf('BlockCommercialConditions') !== -1 );

    return (
      <Document>
        <Page size="A4" style={styles.page} wrap>
          {/* <View render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
          )} fixed >
          </View> */}

          <View render={({ pageNumber, totalPages }) => (
            <View style={{width:'100%', flexDirection: 'row', marginBottom:'10px'}}>
                <Text style={{width:'33%', fontSize:8}}>{displayDate()}</Text>
                <Text style={{width:'33%', fontSize:8, textAlign:'center'}}>{`Página ${pageNumber} / ${totalPages}`}</Text>
                <Text style={{width:'34%', fontSize:8, textAlign:'right'}}>{`Proposta comercial N° ${invoice.invoice_no}`}</Text>
              </View>
          )} fixed/>

          <TopProposal invoice={invoice.empresa} />
          <ProposalNo invoice={invoice} />

          <BillTo title={invoice} />

          {invoice.secondAddress && ( <Address data={invoice.secondAddress} /> )}

          <Thanks />

          {verify && invoice.condicaoComercial?.seller && ( <Seller invoice={invoice} /> )}

          { ( currentBlocks.indexOf('BlockVehicle') !== -1 ) && invoice?.vehicle ? <ProposalVehicle vehicle={invoice.vehicle} /> : <></> }

          { ( currentBlocks.indexOf('BlockItens') !== -1 ) && (<ProposalItemsTable invoice={invoice} /> ) }

          {verify && (
            <>
              <ProposalComercialCondictions
                title={"Condições comerciais: "}
                value={invoice?.condicaoComercial?.obs}
              />
              <ProposalPayment invoice={invoice}/>
              <ProposalFreight invoice={invoice} />
              <ProposalCondition
                title={"Garantia: "}
                value={invoice?.condicaoComercial?.guarantee?.name}
              />

              {/* <ProposalCondition
                title={"Prazo de entrega: "}
                value={invoice?.condicaoComercial?.deadline?.name}
              />
              <ProposalCondition
                title={"Entrega: "}
                value={invoice?.condicaoComercial?.freightType?.name}
              /> */}
              {/* <ProposalCondition
                title={"Condição de Pagamento: "}
                value={invoice?.condicaoComercial?.paymentCondiction?.name}
              />
              <ProposalCondition
                title={"Forma de Pagamento: "}
                value={invoice?.condicaoComercial?.paymentForm?.name}
              /> */}
            </>
          )}

          { ( currentBlocks.indexOf('BlockAdditionalInformation') !== -1 ) && (
              (typeof invoice?.additionalInfo !== 'undefined') ?
                <ProposalContract title={"Informações adicionais: "} value={invoice?.additionalInfo} />
              : <></>
            )  
          }

          { ( currentBlocks.indexOf('BlockContract') !== -1 ) && ( <ProposalContract title={"Contrato: "} value={invoice?.contractModel} /> ) }

          {verify && (
              <>
                <Text style={{ marginTop: '10px' }}>
                  Atenciosamente, {invoice?.condicaoComercial?.seller?.name}
                </Text>
                <Text>Departamento de Vendas</Text>
              </>
          )}
          <ProposalSignature invoice={invoice} />
          {/* <ProposalContract invoice={invoice}/> */}
        </Page>
      </Document>
    );
  };
  
export default Proposal